import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import App from './App.tsx'
import '@fontsource-variable/public-sans'
import '@fontsource-variable/nunito-sans'
import './index.css'

const container = document.getElementById('root')
if (!container) throw new Error('Root element #root not found in index.html')

const app = (
  <StrictMode>
    <App />
  </StrictMode>
)

// Production pages arrive prerendered (scripts/prerender.mjs): hydrate them.
// The dev server serves #root with only a placeholder comment, so render from
// scratch there.
if (container.firstElementChild) hydrateRoot(container, app)
else createRoot(container).render(app)
